export const iconFontAwesomePunctuationSymbolsCheck = (
	<i className="fa-solid fa-check"></i>
);
